import Vue from "vue";
import SnackbarBuilder from "@/assets/plugins/mps-snackbar/SnackbarBuilder";
import SnackbarOverlay from "@/assets/plugins/mps-snackbar/SnackbarOverlay";

const bus = new Vue();

export default {

    install(Vue, options) {
        this.installPrototypes(Vue, options);
        const components = {SnackbarOverlay};
        Object.keys(components).forEach(key => Vue.component(key, components[key]));
    },
    installPrototypes: function (Vue, options) {
        Vue.prototype.$mps_snackbar_event_bus = bus;
        Vue.prototype.$snackbar = (message, timeout = 1500) => new Promise((resolve) => {
            const vm = new Vue();
            return new SnackbarBuilder(bus)
                .message(message)
                .color("black")
                .timeout(timeout)
                .build()
                .show();
        });
        Vue.prototype.$snackbarError = (message, timeout = 1500) => new Promise((resolve) => {
            const vm = new Vue();
            return new SnackbarBuilder(bus)
                .message(message)
                .color("red")
                .timeout(timeout)
                .build()
                .show();
        });
        Vue.prototype.$snackbarSuccess = (message, timeout = 1500) => new Promise((resolve) => {
            const vm = new Vue();
            return new SnackbarBuilder(bus)
                .message(message)
                .color("success")
                .timeout(timeout)
                .build()
                .show();
        });
    }

}
